/**
 * Interfaces de títulos de configuração do plano de aula
 */

export type ListaTituloPlanoAula = TituloPlanoAula[];

export interface TituloPlanoAula {
  ETAPA_BNCC: number;
  CAMPO1: string;
  AUX_CAMPO1: string;
  REL_CAMPO1: string;
  CAMPO2: string;
  AUX_CAMPO2: string;
  REL_CAMPO2: string;
  CAMPO3: string;
  AUX_CAMPO3: string;
  REL_CAMPO3: string;
  CAMPO4: string;
  AUX_CAMPO4: string;
  REL_CAMPO4: string;
  CAMPO5: string;
  AUX_CAMPO5: string;
  REL_CAMPO5: string;
  CAMPO6: string;
  AUX_CAMPO6: string;
  REL_CAMPO6: string;
  CAMPO7: string;
  AUX_CAMPO7: string;
  REL_CAMPO7: string;
  CAMPO8: string;
  AUX_CAMPO8: string;
  REL_CAMPO8: string;
  EXIBEATIVIDADESPERMANENTES: number;
  EXIBERECURSOSUTILIZADOS: number;
  EXIBECATEGORIA: number;
  GERACONTEUDOIA: number;
  MODELORELATORIO?: number;
}

/**
 * Request para buscar títulos de plano de aula
 */
export interface GetTitulosRequest {
  ETAPA_BNCC: number;
  DATABASE: string;
}
